import React from 'react';
import { Button } from 'antd';
import { TextComponent } from 'baseComponents/TextComponent';
import 'baseComponents/HomeNavButtonComponent/homeNavButtonComponent.scss';

interface Props {
  title: string;
  iconName: string;
  onClick: () => void;
}

export const HomeNavButtonComponent: React.FC<Props> = (props) => {
  return (
    <Button onClick={props.onClick} className='button-wrapper'>
      <img
        className='menu-icon'
        src={props.iconName}
        alt='Navigation button icon'
      />
      <TextComponent styleType='warning' size='large' text={props.title} />
    </Button>
  );
};
